import React, { Component } from 'react';
import SignalRCenterProgressComponent from './../component/index';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import {
  clearCenterMessage,
  cancelProcess,
  clearRedirectURL,
  showCenterMessages,
  hideCenterMessages,
  deactivateCenterMessages,
  removeCenterMessage,
} from 'Common/UI/state/actions';

import 'Styles/components/signalRCenterProgress.less';

class SignalRCenterProgressContainer extends Component {
  componentDidMount() {
    this.props.clearCenterMessage();
  }
  componentDidUpdate(preProps) {
    if (
      preProps.GlobalUIState.redirectURLData !==
        this.props.GlobalUIState.redirectURLData &&
      _.has(this.props.GlobalUIState.redirectURLData, 'Data.Path')
    ) {
      this.props.history &&
        this.props.history.replace(
          this.props.GlobalUIState.redirectURLData.Data.Path
        );
    }
  }
  componentWillUnmount() {
    const {
      GlobalUIState: { centerMessages },
    } = this.props;
    this.props.clearRedirectURL();
    if (centerMessages && centerMessages.length) {
      centerMessages.forEach(msg => {
        if (msg.Source === 2 && msg.Status !== 2) {
          this.cancelProcess();
          return false;
        }
      });
    }
  }
  cancelProcess = () => {
    const { processId } = this.props;
    processId && this.props.cancelProcess(processId);
  };
  render() {
    const {
      GlobalUIState: { centerMessagesDisplay, centerMessages },
      showCenterMessages,
      hideCenterMessages,
      deactivateCenterMessages,
      removeCenterMessage,
    } = this.props;

    return (
      <SignalRCenterProgressComponent
        display={centerMessagesDisplay}
        payload={centerMessages}
        cancelProcess={this.cancelProcess}
        showCenterMessages={showCenterMessages}
        hideCenterMessages={hideCenterMessages}
        deactivateCenterMessages={deactivateCenterMessages}
        removeCenterMessage={removeCenterMessage}
      />
    );
  }
}

const mapStateToProps = state => ({
  GlobalUIState: state.GlobalUIState,
});

export const SignalRCenterProgress = connect(
  mapStateToProps,
  {
    clearCenterMessage,
    cancelProcess,
    clearRedirectURL,
    showCenterMessages,
    hideCenterMessages,
    deactivateCenterMessages,
    removeCenterMessage,
  },
  null,
  {
    withRef: true,
  }
)(SignalRCenterProgressContainer);



// WEBPACK FOOTER //
// ./src/components/signalRCenterProgress/container/index.js